export default "__VITE_ASSET__9ToxXLpE__"